import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet'
import { GitPullRequest, ChevronLeft, CheckCircle, MessageSquare, FileText, Activity, Mail, Clock } from 'react-feather'
import { Link, useParams, useLocation, useHistory } from 'react-router-dom'
import Select from 'react-select'
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux'
import dayjs from 'dayjs';
import fileDownload from 'js-file-download'

// variables
import { SITENAME, _optRequestStatuses, _shortcodeLabelVisible } from '../../configuration.js';

// components
import PageHead from '../../components/PageHead';
import Loading from '../../components/Loading';


import RequestFormsStep0 from './step0';
import RequestFormsStep1 from './step1';
import RequestFormsStep2 from './step2';
import RequestFormsStep3 from './step3';
import RequestFormsStep4 from './step4';
import RequestFormsStep5 from './step5';

import RequestFormsStep11 from './step11';

import TimeSheet from './timeSheet.js';

// controllers
import _actions from '../../controllers/redux/actions'
import { _apiGETone, _apiPOST, _apiPUT, _apiGetFile } from '../../controllers/Api';
import { _goBack, _itemByValue, _returnMaxStep } from '../../controllers/Helpers';


export default function RequestForms(props){

  const dispatch = useDispatch();
  const auth = dispatch(_actions.auth.authStatus());

  const location = useLocation()
  const history = useHistory()
  const { id } = useParams()

  const isBackPossible = _goBack(location)

  const [ loading, setLoading ] = React.useState(true);
  const [ data, setData ] = React.useState({})

  const [ step, setStep ] = React.useState(0)
  const [ validStep, setValidStep ] = React.useState(0)
  const [ rand, setRand ] = React.useState(1)

  const [ isShortcodeVisible, setIsShortcodeVisible ] = React.useState(false)
  
  const [ timesheetTotal ,setTimesheetTotal ] = React.useState(0)


  //
  //
  const _title = () =>{
    return data.status ? _optRequestStatuses[data.status-1].label : _optRequestStatuses[0].label
  }


  //
  //
  const _submit = async (k,v) => {

    if(id==='new'){

      const formData = {
        sendEmail:v.sendEmail,
        registrationType:v.registrationType,
        start: v.start,
        status:1,
        userId: auth.response._id,
        clientId: auth.response.clientId
      }

      const insert = await _apiPOST('/change-goal/', formData)
      if(insert.statusCode !== 200){
        toast.error(insert.message);
      }else{
        toast.success(insert.message);
        history.push('/requests/change-goal/'+insert._id)
      }

    }else{

      let formData = {
        invoiceNumber: data.invoiceNumber ? data.invoiceNumber : null
      }

      if(k==='step0'){
        formData = {
          ...formData,
          type: 'step #0',
          registrationType:v.registrationType,
          sendEmail:v.sendEmail,
          start: v.start,
          userId: auth.response._id,
          clientId: auth.response.clientId
        }
      }

      if(k==='step1'){
        formData = {
          ...formData,
          ...v,
          type: 'step #1',
          status:4,
          userId: auth.response._id,
          clientId: auth.response.clientId
        }
      }

      if(k==='step2'){
        formData = {
          ...formData,
          sendEmail:v.sendEmail,
          company:{
            ...data.company,
            ...v.company
          },
          type: 'step #2',
          status:8,
          userId: auth.response._id,
          clientId: auth.response.clientId
        }
      }

      // if(k==='step3'){
      //   formData = {
      //     company:{
      //       ...data.company,
      //       ...v.company
      //     },
      //     type: 'step #3',
      //     status:8,
      //     userId: auth.response._id,
      //     clientId: auth.response.clientId
      //   }
      // }

      if(k==='step4'){
        formData = {
          ...formData,
          sendEmail:v.sendEmail,
          company:{
            ...data.company,
            ...v.company
          },
          invoice: v.invoice,
          datePayment2: v.datePayment2,
          type: 'step #4',
          status:9,
          userId: auth.response._id,
          clientId: auth.response.clientId
        }
      }

      if(k==='step5'){
        formData = {
          ...formData,
          sendEmail:v.sendEmail,
          datePayment: v.datePayment,
          status:10,
          type: 'step #5',
          userId: auth.response._id,
          clientId: auth.response.clientId
        }
      }

      const update = await _apiPUT('/change-goal/'+id, formData)
      if(update.statusCode !== 200){
        toast.error(update.message);
      }else{
        toast.success(update.message);
        setRand(rand+1)
      }

    }

  }


  //
  //
  const _getPdf = async (filename, doc) => {

    const response = await _apiGetFile('/change-goal/pdf/', {
      documentKey:doc,
      requestId:id,
      userId:auth.response._id,
      clientId:auth.response.clientId
    })
    if(response){
      fileDownload(response, filename);
      setRand(rand+1)
    }

  }


  //
  //
  React.useEffect(()=>{

    setLoading(true)

    let route = '/change-goal/'

    const getData = async () =>{
      if(id !== 'new'){
        const res = await _apiGETone(route+id)
        if(!res._id){
          toast.error(res.message);
        }else{
          setData({...res})

          const _validStep = _returnMaxStep(res)
          setValidStep(_validStep)
        }
      }
      setLoading(false)
    }
    if(auth.status){
      setIsShortcodeVisible(_shortcodeLabelVisible())
      getData()
    }

    return (() => [getData])
  },[id, auth.status, auth.response.role, rand])


  //
  //
  const _updateRand = () => {
    setRand(rand+1);
    // console.log('rand',rand)
  }


  //
  //
  return (
    <Fragment>
      <Helmet>
        <title>{_title()} | { SITENAME }</title>
      </Helmet>

      <PageHead
        title={_title()}
        description={`Last update: ${data.dateUpdated ?  dayjs.tz(data.dateUpdated).format('DD.MM.YYYY') : 'N/A'} | by: ${auth.response.firstName} ${auth.response.lastName}`}
        icon={<GitPullRequest size={52}/>}
      >
        {isBackPossible && <Link to={isBackPossible} className="button accent lg outline ml-1"><ChevronLeft/> back</Link>}
      </PageHead>

      {/* <div className="relative w-100">
        <div className="row d-flex justify-content-end">

          {id==='new' && <div className="col-md-4 col-lg-6"><p className="small m-0 py-3">Changing status is disabled during the creation of a new request.</p></div>}
          <div className="col-md-8 col-lg-6">
            <div className="form-group mb-4 d-flex justify-content-start align-items-center">
              <label>STATUS</label>
              <Select
                name="status"
                value={_itemByValue(status, _optRequestStatuses)}
                options={_optRequestStatuses}
                onChange={(e)=> setStatus(e.value)}
                className={`form-control p-0 mx-3`}
                isDisabled={id==='new' || data.status===10 ? true : false}
              />
              <button className="button lg w-100" disabled={id==='new' || data.status===10 ? true : false} onClick={()=>_changeStatus()}>update status</button>
            </div>
          </div>
        </div>
      </div> */}

      <div className="relative w-100 tabs">

        <div className="tabNav">
          <div>
            <button onClick={()=> setStep(0)} className={`${id !== 'new' && 'completed'} ${step === 0 && 'active'}`}>{step >= 0 && id !== 'new' && <CheckCircle size={16}/>}New request</button>
            <button onClick={()=> setStep(1)} className={`${validStep > 1 && 'completed'} ${step === 1 && 'active'}`} disabled={validStep < 1 ? true : false}>{validStep > 1 && <CheckCircle size={16}/>}Step #1</button>
            <button onClick={()=> setStep(2)} className={`${validStep > 2 && 'completed'} ${step === 2 && 'active'}`} disabled={validStep < 2 ? true : false}>{validStep > 2 && <CheckCircle size={16}/>}Step #2</button>
            <button onClick={()=> setStep(4)} className={`${validStep === 4 && 'completed'} ${step === 4 && 'active'}`} disabled={validStep < 3 ? true : false}>{validStep > 3 && <CheckCircle size={16}/>}Step #3</button>
            <button onClick={()=> setStep(5)} className={`${validStep > 5 && 'completed'} ${step === 5 && 'active'}`} disabled={validStep < 4 ? true : false}>{validStep > 5 && <CheckCircle size={16}/>}Step #4</button>
          </div>
          <div>
            <button onClick={()=> setStep(12)} className={`${step === 12 && 'active'}`} disabled={id === 'new' ? true : false}><Clock size={16}/>Timesheet{timesheetTotal !== 0 && ' ('+timesheetTotal+')'}</button>
            <button onClick={()=> setStep(11)} className={`${step === 11 && 'active'}`} disabled={id === 'new' || validStep<2 ? true : false}><FileText size={16}/>Documents</button>
          </div>
        </div>
        <div className="tabContent">

          <div className={step===0 ? '' : 'd-none'}>
            <RequestFormsStep0 auth={auth} data={data} action={_submit} isNew={id==='new'} isShortcodeVisible={isShortcodeVisible}/>
          </div>
          <div className={step===1 ? '' : 'd-none'}>
            <RequestFormsStep1 data={data} action={_submit} isShortcodeVisible={isShortcodeVisible}/>
          </div>
          <div className={step===2 ? '' : 'd-none'}>
            <RequestFormsStep2 data={data} action={_submit} isShortcodeVisible={isShortcodeVisible}/>
          </div>
          <div className={step===3 ? '' : 'd-none'}>
            <RequestFormsStep3 data={data} action={_submit} isShortcodeVisible={isShortcodeVisible}/>
          </div>
          <div className={step===4 ? '' : 'd-none'}>
            <RequestFormsStep4 data={data} action={_submit} isShortcodeVisible={isShortcodeVisible}/>
          </div>
          <div className={step===5 ? '' : 'd-none'}>
            <RequestFormsStep5 data={data} action={_submit} isShortcodeVisible={isShortcodeVisible}/>
          </div>
          
          <div className={step===12 ? '' : 'd-none'}>
            <TimeSheet data={data} updateTimesheetTotal={setTimesheetTotal} />
          </div>

          {data.company && data.company.legalStructures && step===11 &&
          <div>
            <RequestFormsStep11 auth={auth} id={id} rand={rand} data={data} action={_getPdf} validStep={validStep}/>
          </div>
          }

        </div>

        <Loading status={loading}/>
      </div>

    </Fragment>
  );

}
